/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowLineUpRight(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M74.34277,173.65674a8,8,0,0,1,0-11.31348L130.68652,106,86.34277,61.65674A8.0001,8.0001,0,0,1,92,48H192a8.00008,8.00008,0,0,1,8,8V156a8.00018,8.00018,0,0,1-13.65723,5.65674L142,117.31372l-56.34277,56.343a8.00063,8.00063,0,0,1-11.31446,0ZM216,207.99609H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" />
    </Svg>
  );
}

export default ArrowLineUpRight;
